import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const futureTenseQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Elige la opción correcta: 'El próximo verano, yo ___ (viajar) a España.'",
        options: ["viajé", "viajaba", "viajaría", "viajaré"],
        correctAnswerIndex: 3,
        explanation: "Usamos el futuro simple ('viajaré') para hablar de acciones que ocurrirán en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la frase: 'Cuando termine la universidad, ___ (buscar) trabajo.'",
        options: ["buscaré", "busqué", "buscaría", "buscaría"],
        correctAnswerIndex: 0,
        explanation: "El futuro simple ('buscaré') indica una acción que sucederá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la forma correcta: 'Mañana a esta hora, ella ___ (comer) en un restaurante.'",
        options: ["comía", "comeré", "comí", "comerá"],
        correctAnswerIndex: 3,
        explanation: "Usamos el futuro simple ('comerá') para expresar una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Elige la opción correcta: 'No sé si ellos ___ (llegar) a tiempo.'",
        options: ["llegarán", "llegaban", "llegaron", "llegarían"],
        correctAnswerIndex: 0,
        explanation: "El futuro simple ('llegarán') se utiliza para hacer predicciones o suposiciones sobre el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la oración: 'Mañana ellos ___ (decir) la verdad.'",
        options: ["dijeron", "dirán", "decían", "dirían"],
        correctAnswerIndex: 1,
        explanation: "'Dirán' está en futuro simple, que indica una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la opción correcta: 'Para el próximo mes, yo ___ (terminar) el libro.'",
        options: ["termino", "terminaba", "terminaré", "terminaría"],
        correctAnswerIndex: 2,
        explanation: "'Terminaré' está en futuro simple y se utiliza para indicar que la acción ocurrirá antes de un momento futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "¿Cuál es la forma correcta del verbo en la oración: 'El próximo año, ___ (viajar) a España.'?",
        options: ["viajo", "viajaré", "viajaba", "viajaría"],
        correctAnswerIndex: 1,
        explanation: "'Viajaré' está en futuro simple, que denota una acción futura."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la opción correcta: '¿A qué hora ___ (salir, nosotros) mañana?'",
        options: ["salgo", "saldremos", "saldrá", "saldré"],
        correctAnswerIndex: 1,
        explanation: "'saldremos' está en futuro simple por nosotros, indicando una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la oración: 'Si estudias más, ___ (aprovechar) mejor las oportunidades.'",
        options: ["aprovecharás", "aprovechaste", "aprovechabas", "aprovecharías"],
        correctAnswerIndex: 0,
        explanation: "'Aprovecharás' está en futuro simple, mostrando lo que ocurrirá si se cumple una condición."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la opción correcta: 'Este verano ___ (ir) a la playa con mis amigos.'",
        options: ["voy", "iré", "iba", "iría"],
        correctAnswerIndex: 1,
        explanation: "'Iré' está en futuro simple, que denota una acción que va a ocurrir en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "¿Cuál es la forma correcta del verbo en la oración: 'Nosotros ___ (ver) a Juan en la reunión.'?",
        options: ["vemos", "veríamos", "veremos", "veríamos"],
        correctAnswerIndex: 2,
        explanation: "'Veremos' está en futuro simple, indicando una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la frase: 'Ellos ___ (comprar) una nueva casa el próximo año.'",
        options: ["compran", "comprarán", "compraban", "compraron"],
        correctAnswerIndex: 1,
        explanation: "'Comprarán' está en futuro simple, lo que indica que la acción ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Elige la opción correcta: 'Cuando terminen las clases, yo ya ___ (hacer) la tarea.'",
        options: ["habré hecho", "hice", "hago", "haré"],
        correctAnswerIndex: 0,
        explanation: "El futuro perfecto ('habré hecho') se utiliza para hablar de una acción que se completará antes de otro evento futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la forma correcta: 'Nosotros ___ (tener) un examen la próxima semana.'",
        options: ["tenemos", "tendríamos", "teníamos", "tendremos"],
        correctAnswerIndex: 3,
        explanation: "'Tendremos' está en futuro simple, expresando una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "¿Cuál es la forma correcta del verbo en la oración: 'Ellos ___ (salir) de viaje la próxima semana.'?",
        options: ["salen", "saldrán", "saldrían", "salieron"],
        correctAnswerIndex: 1,
        explanation: "'Saldrán' está en futuro simple, que se utiliza para hablar de lo que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la oración: 'En cinco años, yo ___ (vivir) en otro país.'",
        options: ["vivía", "viviría", "viviré", "vivo"],
        correctAnswerIndex: 2,
        explanation: "El futuro simple ('viviré') expresa una acción que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la respuesta correcta: 'La próxima semana ___ (tener) una reunión importante.'",
        options: ["tendré", "tuve", "tenía", "tendría"],
        correctAnswerIndex: 0,
        explanation: "El futuro simple ('tendré') se utiliza para hablar de lo que ocurrirá en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la opción correcta: 'Para el año que viene, ellos ya ___ (terminar) el proyecto.'",
        options: ["terminan", "terminarán", "habrán terminado", "terminaron"],
        correctAnswerIndex: 2,
        explanation: "El futuro perfecto ('habrán terminado') indica que la acción estará completa en un momento específico del futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Elige la opción correcta: 'Nosotros ___ (hacer) una fiesta para celebrar mi cumpleaños.'",
        options: ["haremos", "hicimos", "haríamos", "hacíamos"],
        correctAnswerIndex: 0,
        explanation: "El futuro simple ('haremos') se utiliza para expresar una acción futura."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Completa la frase: 'Ellos ___ (terminar) su trabajo para la fecha límite.'",
        options: ["terminaron", "terminarán", "terminaban", "terminarían"],
        correctAnswerIndex: 1,
        explanation: "El futuro simple ('terminarán') indica una acción que se completará en el futuro."
    },
    {
        category: QuizCategory.FUTURE_TENSE,
        questionText: "Selecciona la opción correcta: 'Cuando llegues, yo ya ___ (salir) de la oficina.'",
        options: ["salí", "salía", "saldré", "habré salido"],
        correctAnswerIndex: 3,
        explanation: "El futuro perfecto ('habré salido') indica una acción que estará completada antes de otro evento futuro."
    }
];

export default futureTenseQuestions;